import { atom } from 'recoil';

// 코드 단순하게(초보용) 켜짐 여부. 기기에 기억
const saved = (() => {
  try {
    return localStorage.getItem('simpleChord') === '1';
  } catch (e) {
    return false;
  }
})();

export default atom<boolean>({
  key: 'simpleChord',
  default: saved,
});
